module.exports = __webpack_public_path__ + "img/banner4.8276d940.jpg";